import { t } from 'i18next';
import { useState } from 'react';
import { SubTabs } from '../SubTabs';
import { RateCicleType, RateModels, TableModels } from '../Tables/TableModels';
import { CicleType, RateModelsType } from '../ClientPanel';
import { Link } from 'react-router-dom';
import { SimpleButton } from '../styles';
import { Profile } from '~/helpers/userProfile';
import { EnergyConsumptionGoal } from '../Energy/EnergyContainer/EnergyConsumptionGoal';

export type EnergyPanelProps = {
  state: {
    rateModels: RateModelsType[];
  };
  deleteCicle: (item: { CICLE_ID: number; CICLE_NAME: string; }) => Promise<void>;
  openCreateCicle: (ModelRate: CicleType, itemToEdit?: RateCicleType) => void;
  deleteModel: (item: { MODEL_ID: number; MODEL_NAME: string; }) => Promise<void>;
  openCreateEditClass: () => void;
  openCreateEditModel: (itemToEdit?: RateModels) => void;
  profile: Profile;
  clientId: number;
}

export const EnergyPanel = ({
  state,
  deleteCicle,
  clientId,
  openCreateCicle,
  deleteModel,
  openCreateEditClass,
  openCreateEditModel,
  profile,
}: EnergyPanelProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState(t('metaDeConsumoDeEnergia'));
  const canManage = profile.manageAllClients || profile.permissions.isAdminConta;
  return (
    <>
      <SubTabs
        tabs={[t('metaDeConsumoDeEnergia'), t('modelosTarifaEnergia')]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === t('metaDeConsumoDeEnergia') && (
        <EnergyConsumptionGoal clientId={clientId} />
      )}
      {activeTab === t('modelosTarifaEnergia') && (
        state.rateModels.length === 0 ? (
          <div>{t('nenhumModelo')}</div>
        ) : (
          <>
            {canManage && (
              <>
                <SimpleButton variant="primary" onClick={() => openCreateEditModel()}>{t('criarNovoModelo').toUpperCase()}</SimpleButton>
                <Link to={`/painel/adicionar-lote/faturas?idcliente=${clientId}`}>
                  <SimpleButton variant="primary">{t('faturas')}</SimpleButton>
                </Link>
              </>
            )}
            <TableModels
              openEditCicle={openCreateCicle}
              rateModels={state.rateModels}
              clientId={clientId}
              onDeleteModelClick={deleteModel}
              onDeleteCicleClick={deleteCicle}
              onEditClick={openCreateEditClass}
              openCreateEditModel={openCreateEditModel}
            />
          </>
        )
      )}

    </>
  );
};
